import React, { useState } from "react";

// Caution badges (backend core/caution.py): risky-but-not-malicious facts. Informational only: they never change
// the score, the tier or automated confirmation. `evidence` / `match` come from scanned content, so they are
// rendered as text. `details` (backend core/summaries.py public_view): the one-line explanation per badge, as the
// public Check page shows it.
export default function CautionBadges({ badges, details }) {
  const [open, setOpen] = useState({});
  if (!badges || badges.length === 0) return null;
  const byId = Object.fromEntries((details || []).map((d) => [d.id, d]));
  return (
    <div style={{ marginTop: 8 }} data-testid="caution-badges">
      <span>Caution: </span>
      {badges.map((b) => (
        <span key={b.id} className="hs-badge hs-badge-warning" style={{ marginRight: 6 }}
              data-testid={`caution-${b.id}`}>{b.label || b.id}</span>
      ))}
      <ul style={{ margin: "6px 0 0", paddingLeft: 18, fontSize: 12, color: "var(--hs-text-muted)" }}>
        {badges.map((b) => {
          const d = byId[b.id];
          return (
            <li key={b.id} data-testid={`caution-explain-${b.id}`}>
              <strong>{b.label || b.id}</strong>
              {d?.explanation ? `: ${d.explanation}` : ""}
              {d?.explanation_source && <span> ({d.explanation_source === "model" ? "written by the model" : "standard text"})</span>}
              {(b.match || b.evidence) && (
                <>
                  {" "}
                  <button type="button" className="hs-link" style={{ fontSize: 12, background: "none", border: 0, padding: 0, cursor: "pointer" }}
                          data-testid={`caution-toggle-${b.id}`} aria-expanded={!!open[b.id]}
                          onClick={() => setOpen({ ...open, [b.id]: !open[b.id] })}>
                    {open[b.id] ? "hide evidence" : "show evidence"}
                  </button>
                  {open[b.id] && (
                    <div data-testid={`caution-evidence-${b.id}`} style={{ marginTop: 2 }}>
                      <div>Triggered by: <code className="hs-mono">{b.match || b.evidence}</code></div>
                      {b.evidence && b.evidence !== b.match && <div>In context: <code className="hs-mono">{b.evidence}</code></div>}
                    </div>
                  )}
                </>
              )}
            </li>
          );
        })}
      </ul>
      <div style={{ fontSize: 12, color: "var(--hs-text-muted)" }}>Informational: these do not change the score or the tier.</div>
    </div>
  );
}
